var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('h2',{staticClass:"title",attrs:{"active":_vm.show}},[_vm._v(_vm._s(_vm.title)),_c('div',{staticClass:"flip",attrs:{"active":_vm.show}})])])}
var staticRenderFns = []

export { render, staticRenderFns }